import {
  INVITE_CREATE_REQUEST,
  SELECT_PROVIDER_ID,
  ALL_PROVIDERS_INVITES,
  RESET_INVITES,
  INVITE_DELETE
} from "../action.types";

export const select = providerId => {
  return {
    type: SELECT_PROVIDER_ID,
    providerId
  };
};

export const createInvites = (agents) => {
  return {
    type: INVITE_CREATE_REQUEST,
    payload: {
      request: {
        method: "post",
        url: `orderServicesInvites`,
        data: agents,
      }
    }
  };
};

export const getInvites = (orderServiceId, page = 1, pageSize = 25) => {
  return {
    type: ALL_PROVIDERS_INVITES,
    payload: {
      request: {
        method: "get",
        url: `orderServicesInvites?pageSize=${pageSize}&page=${page}&orderServiceId=${orderServiceId}`
      }
    }
  };
};

export const inviteDelete = (id) => {
  return {
    type: INVITE_DELETE,
    payload: {
      request: {
        method: "delete",
        url: `orderServicesInvites/${id}`
      }
    }
  };
};

export const resetListInvites = () => {
  return {
    type: RESET_INVITES
  };
};



// WEBPACK FOOTER //
// ./src/redux/providerSelected/providersSelected.action.js